import {omitBy} from "lodash"

/**
 * @description: Helper that will remove nulls and also return null if no keys are left on the object.
 * Was used with permissions in FE.
 */
export default (object: any): any => {
  const filteredObj = omitBy(object, (p: any) => !p)
  return Object.keys(filteredObj).length <= 0 ? null : filteredObj
}
